const timezones = ["America/Chicago", "America/Denver", "America/Los_Angeles", "America/New_York"];

export default timezones;
